import { defineMessages } from 'react-intl';

export default defineMessages({
    seletAddress: {
        "id":   "twia.addressStandardization.pickList.view.Multiple Address",
        "defaultMessage": "Please choose a standardized Address:"
    },
    exactAddress: {
        "id": "twia.addressStandardization.pickList.view.Exact Address",
        "defaultMessage": "Exact Address"
    },
    noMatchFound: {
        "id": "twia.addressStandardization.pickList.view.info.No Match Found",
        "defaultMessage": "The address you entered could not be updated to follow USPS standards. You may be contacted for additional information.",
    },
    hint: {
        "id": "twia.addressStandardization.pickList.view.info.Many Matching Addresses Found.Hint",
        "defaultMessage": 'To proceed, please choose one of the options below and click "OK", or click "Cancel" to return to the previous screen and modify your address.',
    },
    verbose: {
        "id": "twia.addressStandardization.pickList.view.info.Many Matching Addresses Found.Verbose",
        "defaultMessage": "The address you entered could not be updated to follow USPS standards. You may be contacted for additional information."
    },
    tableHeaderAddress: {
        "id": "twia.addressStandardization.pickList.view.Address",
        "defaultMessage": "ADDRESS"
    },
    tableHeaderPostalCode: {
        "id": "twia.addressStandardization.pickList.view.Postal Code",
        "defaultMessage": "POSTAL CODE"
    }
})